import { FC } from "react";
import { useTranslation } from "react-i18next";
import styled from "styled-components";
import { Modal as AntdModal, Space, Typography, ModalProps } from "antd";
import { QuestionCircleOutlined } from "@ant-design/icons";

import { SignatoryWithId } from "@teylor-tools/Api";

const Modal = styled(AntdModal)`
	.ant-modal-body {
		padding: 24px 32px;
	}

	.ant-modal-footer {
		border-top: none;
		padding: 24px 32px;
	}
`;

const QuestionCircleOutlinedIcon = styled(QuestionCircleOutlined)`
	color: var(--ant-primary-color);
	margin-top: 2px;
	font-size: 22px;
`;

const RepresentativesWrapper = styled.div`
	padding: 16px;
	border: 1px solid rgba(0, 0, 0, 0.3);
`;

interface Props {
	representatives: SignatoryWithId[];
	modalProps?: ModalProps;
}

const SubmitConfirmationModal: FC<Props> = ({ representatives, modalProps }: Props) => {
	const { t } = useTranslation();

	return (
		<Modal
			{...modalProps}
			okText={t("application.submitApplicationConfirm")}
			cancelText={t("application.noAdjustRepresentatives")}
			destroyOnClose
			closable={false}
		>
			<Space align="start">
				<QuestionCircleOutlinedIcon />
				<div>
					<Typography.Title level={5}>{t("application.allRepresentativesAdded")}</Typography.Title>

					<Space direction="vertical" size={20} style={{ width: "100%" }}>
						<Typography.Text>{t("application.beforeSubmitConfirmSignatory")}</Typography.Text>
						<RepresentativesWrapper>
							<Typography.Text>{t("application.companyRepresentativesList")}</Typography.Text>
							<ul style={{ padding: "10px 20px", fontWeight: "bold" }}>
								{representatives.map((representative) => (
									<li key={representative.signatory_id}>
										{representative.first_name} {representative.last_name}
									</li>
								))}
							</ul>
						</RepresentativesWrapper>
					</Space>
				</div>
			</Space>
		</Modal>
	);
};

export default SubmitConfirmationModal;
